import * as React from 'react';

import { TOfferGeo } from '../../../types/offer';

export const useLocationId = (geo?: TOfferGeo) => {
  const locationId = React.useMemo(() => {
    if (!geo) {
      return undefined;
    }

    return geo.address?.[0]?.id || undefined;
  }, [geo]);

  return locationId;
};
